import { Link } from "react-router-dom";

export default function Logo({ to = "/", light = false, size = "md", asDiv = false }) {
  const dim = size === "sm" ? "h-8 w-8" : size === "lg" ? "h-12 w-12" : "h-10 w-10";
  const text = size === "lg" ? "text-2xl" : "text-xl";
  const Wrapper = asDiv ? "span" : Link;
  const wrapperProps = asDiv ? {} : { to };
  return (
    <Wrapper {...wrapperProps} className="flex items-center gap-2.5 group pa-focus rounded-lg" data-testid="brand-logo">
      <span className={`relative ${dim} rounded-2xl grid place-items-center transition-transform duration-300 group-hover:scale-105 group-hover:rotate-3`}
        style={{ background: "linear-gradient(135deg, #FF8A33 0%, #FF6B00 55%, #E85D00 100%)", boxShadow: "0 6px 18px rgba(255,107,0,0.4), inset 0 1px 0 rgba(255,255,255,0.35)" }}>
        <svg viewBox="0 0 24 24" className="h-3/5 w-3/5" fill="none">
          <circle cx="7" cy="8" r="2.4" fill="#fff" />
          <circle cx="16.5" cy="7" r="2.1" fill="#FFC94A" />
          <circle cx="8.5" cy="16.5" r="2.1" fill="#FFE0B8" />
          <circle cx="16" cy="16" r="2.6" fill="#fff" />
          <path d="M9 9.5l6-1M9.5 15l5.5.5M9 10.5l6.5 4.5" stroke="rgba(255,255,255,0.55)" strokeWidth="1" strokeLinecap="round" />
        </svg>
        <span className="absolute inset-0 rounded-2xl ring-1 ring-white/25" />
      </span>
      <span className={`font-display font-extrabold tracking-tight ${text} ${light ? "text-white" : "text-[#071126]"} leading-none`}>
        Passion<span className="text-[#FF6B00]">Ate</span>
      </span>
    </Wrapper>
  );
}
